import {Component} from '@angular/core';
import {DataService} from "../../../../services/data.service";
import {DialogRef} from "@angular/cdk/dialog";

@Component({
  selector: 'app-forgot-password-popup',
  templateUrl: './forgot-password-popup.component.html',
  styleUrls: ['./forgot-password-popup.component.scss']
})
export class ForgotPasswordPopupComponent {
  public emailForPassword: string;
  public forgettingPassword: boolean;
  public forgotPasswordMessage: string;

  constructor(
    private dialogRef: DialogRef<null>,
    private dataService: DataService
  ) {
  }

  close() {
    this.dialogRef.close()
  }

  public async resetPassword(): Promise<void> {
    if (!this.canForgetPassword()) {
      return;
    }
    try {
      const protocol = location.protocol;
      const host = location.host;
      this.forgettingPassword = true;
      await this.dataService.forgotPassword(this.emailForPassword, `${protocol}//${host}/reset-password`);
      this.forgotPasswordMessage = `Eine E-Mail mit einer Anleitung wurde an ${this.emailForPassword} geschickt. Bitte prüfen Sie auch Ihren Spam-Ordner.`;
    } catch {
      this.forgotPasswordMessage = 'Die eingegebene Email-Adresse ist uns leider nicht bekannt.';
    } finally {
    }
  }

  public canForgetPassword(): boolean {
    console.log(/\S+@\S+\.\S+/.test(this.emailForPassword))
    return !this.forgettingPassword && /\S+@\S+\.\S+/.test(this.emailForPassword);
  }
}
